import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';

const Form = (props) => {
    const handleChange = (prop) => (event) => {
        props.setValues({...props.values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        props.setErrors({...props.errors, [prop]: ''});
    };

    return (
        <>
            <TextField label="URL"
                       value={props.values.url}
                       onChange={handleChange('url')}
                       error={props.errors.url.length > 0}
                       helperText={props.errors.url}
                       onFocus={handleFocus('url')}
                       autoFocus={true}
            />
        </>
    );
};

Form.propTypes = {
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
};

export default Form;
